import { get } from '@/api/base'

const containerFiltersApi = {
  getAll: async companyUuid => {
    const response = await get({ path: `companies/${companyUuid}/container_filters` })
    return response.success ? response.data : response
  },
}

export default containerFiltersApi
